<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Sobre a Bona Imóveis';
</script>

<PageHeader title={titlePage} type={1}>
	<span slot="content">
		<h2 class="color-secondary">"Zelar pelo seu patrimônio é a nossa missão"</h2>
	</span>
</PageHeader>

<div class="container">
	<iframe title="Vídeo institucional" class="img-responsive min-w--50 " height="350" src="https://www.youtube.com/embed/m1ump4-b1yg?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<p>A determinação e a forma de lidar com nossos clientes faz a nossa empresa crescer com solidez e modernização. </p>
	<p>Com ampla sede própria, dotada de estacionamento, demonstra que tem fundamento real e robustez, comprovando sua efetiva e eficaz atuação no ramo imobiliário.</p>
	<p>Desde 1991 está voltada à administração de condomínios, aluguéis e vendas, contando com uma equipe de colaboradores constantemente atualizada com cursos de aperfeiçoamento, tanto profissional como pessoal, buscando melhoria permanente na qualificação do atendimento.</p>
	<p>Com o passar dos anos desenvolvemos e aprimoramos um serviço inteligente de administração de condomínios. Os serviços prestados facilitam a vida dos síndicos e condôminos, agilizando a burocracia e trazendo maior tranquilidade e economia.</p>
	<p>A pessoalidade e a importância que dedicamos ao cliente é o que ressalta a agilidade no atendimento, seja na administração de condomínios, como nas locações ou vendas.</p>
	<div class="gridbox grid-size--2 grid-size-sm--1 pt-20">
		<img src="assets/images/sobre.jpg" class="img-responsive round-all" alt="Sede da Bona Imóveis" />
		<div class="sm-pt-10">
			<div class="item flex flex-column flex-center gap-20">
				<div class="">
					<i class="fas fa-bullseye fa-fw fa-5x color-accent"></i>
				</div>
				<div class="flex-1">
					<h3 class="text-center">Missão</h3>
					<p>Oferecer a todos os clientes o máximo de empenho profissional, objetivando alcançar a melhor qualidade de nossos serviços, com ética, eficácia e responsabilidade social.</p>
					<hr/>
				</div>
			</div>
			<div class="item flex flex-column flex-center gap-20">
				<div class="">
					<i class="far fa-lightbulb fa-fw fa-5x color-accent"></i>
				</div>
				<div class="flex-1">
					<h3 class="text-center">Credo</h3>
					<p>Acreditamos que através do contínuo aprimoramento estaremos oferecendo a segurança de um trabalho bem feito e com isto garantindo sucesso e competitividade no mercado.</p>
				</div>
			</div>
		</div>
	</div>
</div>